import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettlementContracts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.79866 2.89243L7.15631 5.53475C7.15121 5.53983 7.14804 5.546 7.14296 5.55113C7.7939 5.45632 8.46262 5.52132 9.08251 5.76304L10.8759 3.96969C11.47 3.37557 12.4362 3.37557 13.0303 3.96969C13.6245 4.56376 13.6245 5.53005 13.0303 6.12412C12.929 6.22548 10.2352 8.91926 10.388 8.76644C9.78921 9.3653 8.80679 9.33968 8.23354 8.76644C7.93665 8.46954 7.45326 8.46954 7.15631 8.76644L6.69385 9.2289C6.82212 9.44686 6.96918 9.65659 7.15631 9.84372C8.28468 10.9721 10.2269 11.0622 11.4489 9.85707C11.454 9.85199 11.4602 9.8488 11.4653 9.84372L14.1076 7.2014C15.2975 6.01149 15.2975 4.08235 14.1076 2.89243C12.9177 1.70252 10.9886 1.70252 9.79866 2.89243Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.92327 11.2313L6.12413 13.0305C5.53006 13.6246 4.56376 13.6246 3.9697 13.0305C3.37558 12.4364 3.37558 11.4701 3.9697 10.876C4.071 10.7747 6.77055 8.07513 6.61777 8.22791C7.21659 7.62909 8.19901 7.65466 8.77226 8.22791C9.06915 8.52485 9.55257 8.52485 9.84949 8.22791L10.312 7.76544C10.1837 7.54748 10.0366 7.33776 9.84949 7.15068C8.72328 6.02442 6.78246 5.92859 5.5569 7.1373C5.55179 7.14237 5.54565 7.14557 5.54052 7.15068L2.89242 9.79878C1.70255 10.9886 1.7025 12.9178 2.89242 14.1077C4.08233 15.2976 6.01152 15.2976 7.20138 14.1077L9.84946 11.4596C9.85456 11.4545 9.85774 11.4484 9.86282 11.4432C9.21187 11.5381 8.54318 11.473 7.92327 11.2313Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8666 12.8308L11 13.4769L12.8666 14.2667L13.6133 16.1333L14.4346 14.2667L16.1892 13.4769L14.4346 12.8308L13.6133 11L12.8666 12.8308Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.227 15.8278L13.9837 16.9278L17.227 18.2722L18.5243 21.45L19.9513 18.2722L23 16.9278L19.9513 15.8278L18.5243 12.7111L17.227 15.8278Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3892 20.0393L12.7892 19.5624L13.3492 18.2111L13.9652 19.5624L15.2811 20.0393L13.9652 20.6222L13.3492 22L12.7892 20.6222L11.3892 20.0393Z",
			fill: "currentColor"
		})
	]
});
export default SvgSettlementContracts;
